import { render, staticRenderFns } from "./squareOnImage.vue?vue&type=template&id=0c94c1a8&scoped=true"
import script from "./squareOnImage.vue?vue&type=script&lang=js"
export * from "./squareOnImage.vue?vue&type=script&lang=js"
import style0 from "./squareOnImage.vue?vue&type=style&index=0&id=0c94c1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c94c1a8",
  null
  
)

export default component.exports